module.exports = __webpack_public_path__ + "img/logo-text.cbdb48b4.webp";